import config from 'src/config'

function load(component) {
  return () => import(`src/${component}.vue`)
}

const MODULE_PATH = '/members/management/'

export default [
  {
    path: MODULE_PATH,
    component: load('containers/Full'),
    name: 'Members',
    meta: {
      title: 'Common.menu.members.management',
      menuItem: true,
      sorting: config.sidebar.menu.sorting.modules.members,
      icon: 'face',
    },
    children: [
      {
        path: MODULE_PATH + 'personal/data/list',
        component: load('application/members/components/membersList'),
        name: 'Personal Data List',
        meta: {
          title: 'Common.menu.sub.members.personalList',
          icon: 'contacts',
          menuItem: true,
          sorting: 301,
        },
      },
      {
        path: MODULE_PATH + 'tree/placement',
        component: load('application/members/components/membersPlacementTree'),
        name: 'Placement Tree Diagram',
        meta: {
          title: 'Common.menu.sub.members.placementTree',
          icon: 'device_hub',
          menuItem: true,
          sorting: 302,
        },
      },
      {
        path: MODULE_PATH + 'tree/sponsor',
        component: load('application/members/components/membersSponsorTree'),
        name: 'Sponsor Tree',
        meta: {
          title: 'Common.menu.sub.members.sponsorTree',
          icon: 'device_hub',
          menuItem: true,
          sorting: 303,
        },
      },
      {
        path: MODULE_PATH + 'sponsor/downline',
        component: load('application/members/components/evo/MemberSponsorDownlineList'),
        name: 'Sponsor Downline',
        meta: {
          title: '@memberSponsorDownlineListing.title',
          icon: 'device_hub',
          menuItem: true,
          sorting: 303,
        },
      },
      {
        path: MODULE_PATH + 'password/reset',
        component: load('application/members/components/memberPasswordReset'),
        name: 'Member Reset Password',
        meta: {
          title: 'Common.menu.sub.members.resetPassword',
          icon: 'security',
          menuItem: true,
          sorting: 304,
        },
      },
      {
        path: MODULE_PATH + 'setup/[:memberID?]',
        component: load('application/members/components/memberSetupArea'),
        name: 'Member Setup',
        meta: {
          title: 'Common.menu.sub.members.setup',
          icon: 'face',
          menuItem: false,
          sorting: 305,
        },
        props: true,
      },
      {
        path: MODULE_PATH + 'setup/[:memberID?]',
        component: load('application/members/components/memberSetupAreaVN'),
        name: 'Member Setup Vn',
        meta: {
          title: 'Common.menu.sub.members.setup',
          icon: 'face',
          menuItem: false,
          sorting: 313,
        },
        props: true,
      },
      {
        path: MODULE_PATH + 'rank/list',
        component: load('application/members/components/memberRankList'),
        name: 'Member Rank List',
        meta: {
          title: 'Common.menu.sub.members.rank',
          icon: 'face',
          menuItem: true,
          sorting: 306,
        },
      },
      {
        path: MODULE_PATH + 'rank/update/[:userID]',
        component: load('application/members/components/memberRankUpdate'),
        name: 'Member Rank Update',
        props: true,
        meta: {
          title: 'members.rankUpdate.title',
          icon: 'face',
          menuItem: false,
          sorting: 307,
        },
      },
      {
        path: MODULE_PATH + 'status/list',
        component: load('application/members/components/memberStatusList'),
        name: 'Member Status List',
        props: true,
        meta: {
          title: 'Common.menu.sub.members.status',
          icon: 'face',
          menuItem: true,
          sorting: 308,
        },
      },
      {
        path: MODULE_PATH + 'status/update/[:userID]',
        component: load('application/members/components/memberStatusUpdate'),
        name: 'Member Status Update',
        props: true,
        meta: {
          title: 'members.statusUpdate.title',
          icon: 'face',
          menuItem: false,
          sorting: 309,
        },
      },
      {
        path: MODULE_PATH + 'migration/list',
        component: load('application/members/components/memberMigrationList'),
        name: 'Member Migration',
        meta: {
          title: 'Common.menu.sub.members.migration',
          icon: 'face',
          menuItem: true,
          sorting: 310,
        },
      },
      {
        path: MODULE_PATH + 'migration/update/[:userID]',
        component: load('application/members/components/memberMigrationUpdate'),
        name: 'Member Migration Update',
        props: true,
        meta: {
          title: 'members.migrationUpdate.title',
          icon: 'face',
          menuItem: false,
          sorting: 311,
        },
      },
      {
        path: MODULE_PATH + 'downline/bv/sv/list',
        component: load('application/members/components/memberDownlineList'),
        name: 'Downline BV/SV Listing',
        meta: {
          title: 'modules.members.downlineBvSvListing.title',
          icon: 'device_hub',
          menuItem: true,
          sorting: 312,
        },
      },
    ],
  },
]
